import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Product from './icon-product.svg';

// Use BoxRegularIcon instead
// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Product {...validProps} />;
}
SvgComponent.iconName = 'product';

/**
 * @deprecated This is a legacy icon
 */
export const ProductIcon = svgIconWrapper(SvgComponent);
